module.exports = __webpack_public_path__ + "static/media/KeyframeWatermark.dca5b546.png";


//////////////////
// WEBPACK FOOTER
// ./src/Features/Telestrations/Assets/KeyframeWatermark.png
// module id = 7090
// module chunks = 0